import router from './index'
import { api } from '@/plugins/axios'

const routes = [
  {
    path: '/',
    name: 'home',
    component: async () => await import('@/views/capo/HomeView.vue'),
  },
  {
    path:'/create-campaign',
    name:'create-campaign',
    component:() => import('@/views/capo/CreateCampaign.vue')
  },
  {
    path:'/insert-invoice',
    name:'insert-invoice',
    component:() => import('@/views/capo/InsertInvoice.vue')
  },
  {
    // Data import (درج داده) pages: purchases, weekly returns, customers.
    path:'/import/purchases',
    name:'import-purchases',
    component:() => import('@/views/capo/ImportPurchases.vue')
  },
  {
    path:'/import/returns',
    name:'import-returns',
    component:() => import('@/views/capo/ImportReturns.vue')
  },
  {
    path:'/import/customers',
    name:'import-customers',
    component:() => import('@/views/capo/ImportCustomers.vue')
  },
  {
    meta: { title: 'menu.editCampaign' },
    path:'/campaigns/edit/:id',
    name:'edi-campaign',
    component:() => import('@/views/capo/EditCampaign.vue')
  },
  {
    path:'/admins',
    name:'admins',
    component:() => import('@/views/capo/AdminsView.vue')
  },
  {
    path:'/report/categories',
    name:'report-categories',
    component:() => import('@/views/capo/CategoriesView.vue')
  },
  {
    path:'/report/grades',
    name:'report-grades',
    component:() => import('@/views/capo/GradesView.vue')
  },
  {
    path:'/products',
    name:'products',
    component:() => import('@/views/capo/ProductsView.vue')
  },
  {
    path:'/producers',
    name:'producers',
    component:() => import('@/views/capo/ProducersView.vue')
  },
  {
    path:'/cities',
    name:'cities',
    component:() => import('@/views/capo/CitiesView.vue')
  },
  {
    path:'/provinces',
    name:'provinces',
    component:() => import('@/views/capo/ProvincesView.vue')
  },
  {
    path:'/report/audit-events',
    name:'report-audit-events',
    component:() => import('@/views/capo/AuditEventsView.vue')
  },
  {
    path:'/report/login-attempts',
    name:'report-login-attempts',
    component:() => import('@/views/capo/LoginAttemptsView.vue')
  },
  {
    path:'/gift-categories',
    name:'gift-categories',
    component:() => import('@/views/capo/GiftCategoriesView.vue')
  },
  {
    path:'/gift-products',
    name:'gift-products',
    component:() => import('@/views/capo/GiftProductsView.vue')
  },
  {
    path:'/banners',
    name:'banners',
    component:() => import('@/views/capo/BannersView.vue')
  },
  {
    path:'/spinners',
    name:'spinners',
    component:() => import('@/views/capo/SpinnersView.vue')
  },
  {
    path:'/lotteries',
    name:'lotteries',
    component:() => import('@/views/capo/LotteriesView.vue')
  },
  {
    path:'/tickets',
    name:'tickets',
    component:() => import('@/views/capo/TicketsView.vue')
  },
  {
    meta: { title: 'menu.ticketDetail' },
    path:'/tickets/:id',
    name:'ticket-detail',
    component:() => import('@/views/capo/TicketDetailView.vue')
  },
  {
    path:'/ticket-departments',
    name:'ticket-departments',
    component:() => import('@/views/capo/TicketDepartmentsView.vue')
  },
  {
    path:'/ticket-sources',
    name:'ticket-sources',
    component:() => import('@/views/capo/TicketSourcesView.vue')
  },
  {
    path:'/notifications',
    name:'notifications',
    component:() => import('@/views/capo/NotificationsView.vue')
  },
  {
    // Same URL the menu entry already points at; a static route wins over the
    // shared '/form/:name' form-builder route, so this page renders the custom
    // view instead of files/form/admin/upload-voucher.json.
    path:'/form/upload-voucher',
    name:'upload-voucher',
    meta: { title: 'menu.uploadVoucher' },
    component:() => import('@/views/capo/UploadVoucher.vue')
  },
  {
    // Same URL the customer report's edit action already points at; a static
    // route wins over the shared '/admin/form/:name/:param' form-builder route.
    // Renders the custom core-backed edit page (shahkar national_id lock +
    // mobile removal) instead of files/form/admin/edit-customer.json.
    path:'/admin/form/edit-customer/:param',
    name:'edit-customer',
    component:() => import('@/views/capo/EditCustomer.vue')
  },
  {
    path:'/grades/rearrange',
    name:'grade-rearrange',
    component:() => import('@/views/capo/RearrangeGrades.vue')
  }
]

/**
 * capo pageview capture (Req 6).
 *
 * Registers a global `router.afterEach` hook that fire-and-forget POSTs the
 * visited route path to `/api/admin/pageview`. The capture is skipped when the
 * admin is not logged in (no auth token) and any error is swallowed.
 *
 * `router` is the shared router created in `./index`. Because `./index`
 * imports this module to read the `routes` array, there is a circular
 * dependency: at the time this module first evaluates, `./index` has not yet
 * created the router. Registration is therefore deferred to the next macrotask
 * (by which point the shared `export default router` has resolved) and guarded
 * with a flag so repeated evaluations (e.g. dev HMR) do not stack hooks.
 */
let pageviewRegistered = false
const registerPageviewTracking = (): void => {
  if (pageviewRegistered) return
  pageviewRegistered = true

  router.afterEach((to) => {
    // skip when not logged in
    if (!localStorage.getItem('auth_token')) return
    // fire-and-forget; never block navigation or surface errors
    void api.post('/admin/pageview', { path: to.fullPath }).catch(() => {})
  })
}

// Defer so the circular import of './index' is fully initialized.
setTimeout(registerPageviewTracking, 0)

export default routes
